// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_au-3";
export var contentContainer = "_au-0";
export var editorContainer = "_au-1";
export var quillInputForm = "_au-2";
export var zoneDivider = "_au-4";